export default __webpack_public_path__ + "static/media/369.70b27dd1.jpg";